<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="8" md="6" lg="4" >
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <div align="center"><img class="navbar-brand-minimized" src="/img/brand/sygnet.png" height="60" alt="Inovace Logo"></div>
                  <h1 align="center">Login</h1>
                  <p align="center" class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" v-model="usernameOrEmail" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" v-model="password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="5">
                      <b-button variant="primary" class="px-4" @click="login({usernameOrEmail,password})">Login</b-button>
                    </b-col>
                    <b-col cols="7" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'Login',
  data: function () {
    return {
      usernameOrEmail: "",
      password:""
    }
  },
  methods:{
    ...mapActions([
      'login'
    ])
  }
}
</script>
